<div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-px-8">
  <div class="tw-w-full tw-h-fit tw-bg-white tw-border tw-border-grey-600 tw-rounded-[10px] tw-py-8 tw-px-4">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">{{ "change-name" | translate }}</p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-icon.svg" />
      </div>
    </div>
    <div class="tw-w-full tw-h-fit">
      <form [formGroup]="changeForm">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-mb-2">{{ "full-name" | translate }}</p>
        <input
          class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-border tw-border-grey-600 tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
          type="text"
          formControlName="name"
          placeholder="{{ 'full-name-placeholder' | translate }}"
        />
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-danger tw-mb-6">
          {{ isErrorText | translate }}
        </p>
      </form>
    </div>
    <div class="tw-w-full tw-h-2"></div>
    <button (click)="save()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-bold tw-text-sm tw-text-secondary tw-bg-primary tw-rounded-[5px] tw-py-4">
      {{ "save" | translate }}
    </button>
  </div>
</div>
